// import moment from "moment";

const timeoffJournalBulkUploadColumns = [
  {
    field: "EntryType",
    key: "EntryType",
    title: "Entry Type",
    headerAlign: "left",
    align: "left",
    renderBodyCell: ({ row }) => row.EntryType.split(/(?=[A-Z])/).join(" "),
  },
  {
    field: "TimeoffJournal",
    key: "TimeoffJournal",
    title: "Timeoff Journal",
    headerAlign: "left",
    align: "left",
  },
  {
    field: "TimeoffType",
    key: "TimeoffType",
    title: "Timeoff Type",
    headerAlign: "left",
    align: "left",
  },
  {
    field: "EmployeeNo",
    key: "EmployeeNo",
    title: "Employee No",
    headerAlign: "left",
    align: "left",
  },
  {
    field: "Days",
    key: "Days",
    title: "Days",
    headerAlign: "center",
    align: "center",
  },
  {
    field: "StartDate",
    key: "StartDate",
    title: "Start Date",
    headerAlign: "center",
    align: "center",
    // renderBodyCell: ({ row }) =>
    //   moment(row.StartDate).format("DD/MM/YYYY"),
  },
  {
    field: "EndDate",
    key: "EndDate",
    title: "End Date",
    headerAlign: "center",
    align: "center",
    // renderBodyCell: ({ row }) =>
    //   moment(row.EndDate).format("DD/MM/YYYY"),
  },
];

export default timeoffJournalBulkUploadColumns;
